//
import createItem from './createItem'
import fetchAll from './fetchAll'
import fetchById from './fetchById'
import fetchDataTable from './fetchDataTable'
import massiveUpdateSalePrices from './massiveUpdateSalePrices'
import updateItem from './updateItem'
import fetchBySearch from './fetchBySearch'
import suggestInternalCode from './suggestInternalCode'
import upcImageGenerator from './upcImageGenerator'
//
export default {
    createItem,
    dtFetchData: fetchDataTable,
    fetchAll,
    fetchById,
    massiveUpdateSalePrices,
    updateItem,
    fetchBySearch,
    suggestInternalCode,
    upcImageGenerator,
}
